import { render, staticRenderFns } from "./InternalCookiePolicy.vue?vue&type=template&id=bda6fe9c&scoped=true"
import script from "./InternalCookiePolicy.vue?vue&type=script&lang=ts"
export * from "./InternalCookiePolicy.vue?vue&type=script&lang=ts"
import style0 from "./InternalCookiePolicy.vue?vue&type=style&index=0&id=bda6fe9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.13_babel-core@6.26.3_css-loader@6.11.0_webpack@5.98._lpz7yfflcfbikbc3glhfyeagle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda6fe9c",
  null
  
)

export default component.exports